import _ from 'lodash';

export var injectScript = {
	css: (attributes) => {
		return generic('link', {
			type: 'text/css',
			rel: 'stylesheet',
			...attributes
		});
	},
	js: (attributes) => {
		return generic('script', {
			type: 'text/javascript',
			...attributes
		});
	}
};

const generic = (type, attributes) => {
	const link = document.createElement(type);
	_.each(attributes, (value, key) => {
		link.setAttribute(key, value);
	});
	document.getElementsByTagName("head")[0].appendChild(link);
	return link;
};
